import request from '@/utils/request'


export function starSta(query) {
  return request({
    url: '/statistics/star/star/page',
    method: 'get',
    params: query
  })
}